/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Intro_WhatInputs */



/**
* | output |
* | --- |
* | "Hi, I'm Uno, your personal assistant here in oneAI. I'll guide you through the platform now, and I'm always around afterwards - whenever you have a question ..." |
*
* @param {Onboarding_Intro_WhatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_intro_what = /** @type {((inputs?: Onboarding_Intro_WhatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Intro_WhatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hallo, ich bin Uno, dein persönlicher Assistent hier in oneAI. Ich führe dich jetzt durch die Plattform und bin danach immer für dich da - wenn du eine Frage zu oneAI hast, frag mich einfach. oneAI selbst ist der KI-Arbeitsplatz für dein Unternehmen: ein Ort, um mit den besten KI-Modellen zu chatten, mit deinen eigenen Dokumenten zu arbeiten und Assistenten für dein Team zu bauen - gehostet in der EU und gebaut für den EU AI Act.")
	return /** @type {LocalizedString} */ ("Hi, I'm Uno, your personal assistant here in oneAI. I'll guide you through the platform now, and I'm always around afterwards - whenever you have a question about oneAI, just ask me. oneAI itself is the AI workspace for your company: one place to chat with the best AI models, work with your own documents, and build assistants for your team - hosted in the EU and built for the EU AI Act.")
});